'use strict';

var illustration = require('../../../../../../../../../../_virtual/illustration.cjs');
var intentionColors = require('../../base/ds5/intentionColors.cjs');

var hasRequiredIllustration;

function requireIllustration () {
	if (hasRequiredIllustration) return illustration.__exports;
	hasRequiredIllustration = 1;

	var intentionColors$1 = intentionColors.__require();

	var ILLUSTRATION_INTENTIONS = /*#__PURE__*/ function(ILLUSTRATION_INTENTIONS) {
	    ILLUSTRATION_INTENTIONS[ILLUSTRATION_INTENTIONS["neutral"] = intentionColors$1.INTENTION_COLORS.neutral] = "neutral";
	    ILLUSTRATION_INTENTIONS[ILLUSTRATION_INTENTIONS["success"] = intentionColors$1.INTENTION_COLORS.success] = "success";
	    ILLUSTRATION_INTENTIONS[ILLUSTRATION_INTENTIONS["info"] = intentionColors$1.INTENTION_COLORS.info] = "info";
	    ILLUSTRATION_INTENTIONS[ILLUSTRATION_INTENTIONS["critical"] = intentionColors$1.INTENTION_COLORS.critical] = "critical";
	    ILLUSTRATION_INTENTIONS[ILLUSTRATION_INTENTIONS["recur"] = intentionColors$1.INTENTION_COLORS.recur] = "recur";
	    ILLUSTRATION_INTENTIONS[ILLUSTRATION_INTENTIONS["warning"] = intentionColors$1.INTENTION_COLORS.warning] = "warning";
	    ILLUSTRATION_INTENTIONS[ILLUSTRATION_INTENTIONS["discovery"] = intentionColors$1.INTENTION_COLORS.discovery] = "discovery";
	    return ILLUSTRATION_INTENTIONS;
	}({});

	illustration.__exports.ILLUSTRATION_INTENTIONS = ILLUSTRATION_INTENTIONS;
	
	return illustration.__exports;
}

exports.__require = requireIllustration;
//# sourceMappingURL=illustration.cjs.map
